<div class="flex flex-col gap-1.25">
  <div class="main flex items-center justify-between h-[2.75rem]">
    <!-- LEFT SELECTOR AND INPUT -->
    <div class="flex flex-row gap-0.46875">
      <div class="w-[35rem] bg-black-3 h-[2.5rem] rounded-[0.5rem]"></div>
      <div class="w-[8rem] bg-black-3 h-[2.5rem] rounded-[0.5rem]"></div>
      <div class="w-[8rem] bg-black-3 h-[2.5rem] rounded-[0.5rem]"></div>
    </div>
    <!-- RIGHT BUTTONS -->
    <div class="flex flex-row gap-0.46875">
      <div class="w-[5rem] bg-black-3 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[5rem] bg-black-3 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[5rem] bg-black-3 h-[1.85rem] rounded-[1.5rem]"></div>
      <div class="w-[8.55rem] bg-black-3 h-[1.85rem] rounded-[1.5rem]"></div>
    </div>
  </div>

  <!-- TABLE  -->
  <div class="main">
    <div class="table-fms">
      <table>
        <thead>
          <tr>
            <th class="fix-w-19p75"></th>
            <th class="fix-w-0p25 blank-space"></th>
            <th *ngFor="let header of ['','','','','','','','','','', '', '', '']; let i = index"
                class="fix-w-5p5"
                [class.blank-space]="[5, 10, 15].includes(i)">
              {{header}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of [].constructor(25)"
              class="animation-wrapper"
              app-table-empty-state
              [tdAmount]="15"
              [blankSpaceIndices]="[1, 7, 12]">
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
